import React, { useState } from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import DateCommon from '../Date';

import { CSS_UID, calculateAge } from './index.utils';
import { fieldShape } from './index.shape';

import './index.scss';

/**
 * text field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const BirthDateCommon = props => {
  const {
    field: { name, value },
    disabled,
    eventEmitter,
    showError,
    existError,
    param,
  } = props;
  const [age, setAge] = useState(0);

  /**
   * set age
   * @param {*} ageLocal
   */
  const setAgeLocal = ageLocal => {
    const result = calculateAge(ageLocal, param?.methodCalculateAge);
    setAge(result);
  };

  /**
   * label age
   */
  const displayAge = typeof param?.displayAge === 'boolean' ? param?.displayAge : true;
  const labelAge = displayAge ? <span className={cn(CSS_UID, 'label_age')}> {age} ans </span> : '';

  return (
    <div style={{ flexWrap: 'nowrap', display: 'flex' }}>
      <DateCommon
        field={{ name, value }}
        disabled={disabled}
        showError={showError}
        existError={existError}
        min={param?.min}
        max={param?.max}
        eventEmitter={event => {
          setAgeLocal(event);
          eventEmitter(event);
        }}
      />
      <div style={{ paddingTop: '10px', minWidth: '70px' }}>{labelAge}</div>
    </div>
  );
};

BirthDateCommon.propTypes = {
  field: PropTypes.shape(fieldShape),
  disabled: PropTypes.bool,
  existError: PropTypes.bool,
  showError: PropTypes.bool,
  eventEmitter: PropTypes.func.isRequired,
  param: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string,
    methodCalculateAge: PropTypes.string,
    displayAge: PropTypes.bool,
  }),
};

BirthDateCommon.defaultProps = {
  field: {
    value: undefined,
  },
  existError: false,
  showError: false,
  disabled: false,
  param: {},
};

export default BirthDateCommon;
